"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Solution MZ for client FE
 * Api Consumer Solution MZ
 *
 * The version of the OpenAPI document: v1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MgmBoxStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var MgmBoxStatus;
(function (MgmBoxStatus) {
    MgmBoxStatus["Ok"] = "OK";
    MgmBoxStatus["Error"] = "ERROR";
    MgmBoxStatus["Unreached"] = "UNREACHED";
    MgmBoxStatus["Pending"] = "PENDING";
})(MgmBoxStatus || (exports.MgmBoxStatus = MgmBoxStatus = {}));
